import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [성능/운영>요약] 네트워크 장비 구성정보 위젯 정보 조회
   * @author jeee12
   * @param  {Object} params objId, managegroupId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  getNetdeviceConfigurationInfo(params) {
    return axios.get(`${baseUrl}/performance/summary/netdevice/get-configuration-info.do`, { params });
  },
  /**
   * [성능/운영>요약] Netdice 성능위젯 정보 조회
   * @author kimjy
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getSummaryRscRsltList(params) {
    return axios.post(`${baseUrl}/performance/summary/netdevice/get-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-list.do`, params);
  },
  /**
   * [성능/운영>요약] Netdice 성능위젯 정보 조회 (후면)
   * @author kimjy
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getSummaryRscRsltBackList(params) {
    return axios.post(`${baseUrl}/performance/summary/netdevice/get-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-back-list.do`, params);
  },
  /**
   * [netdevicePerformanceInfoAPI 장비 모델링을 수행한다.]
   * @author {Yang}
   * @param  {[PerformanceParamVO]} params [objId]
   * @return {[type]}        [description]
   */
  executeNetdeviceModeling(params) {
    return axios.post(`${baseUrl}/performance/execute-netdevice-modeling.do`, params);
  },
  /**
   * [성능/운영 > 슬라이딩 팝업 > 명령어 수행] 네트워크 장비 벤더의 스크립트 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceTemplateScriptList(params) {
    return axios.post(`${baseUrl}/performance/get-netdevice-template-script-list.do`, params);
  },
  /**
   * 사용자 정의 OID 자원 현재 값 목록 조회
   * @author Ju
   * @param  {[type]} objId [description]
   * @return {[type]}       [description]
   */
  getUserDefineOidRscCurrentValues(objId) {
    return axios.get(`${baseUrl}/performance/netdevice/get-user-define-oid-rsc-current-values.do`, { params: { objId } });
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/netdevice/netdevice-info.js